export class ErrorSemantico extends Error {}
export class ErrorTecnico extends Error {}

export class ListaDeErroresDelDominio extends ErrorSemantico {
    constructor(data) {
        super();
        this.data = data;
    }
}

export class ErrorEnIdSesion extends ErrorSemantico {}

export class ErrorEntidadNotFound extends ErrorSemantico {}

export class ErrorEntidadDuplicada extends ErrorSemantico {}

export class ErrorConflictoconEntidad extends ErrorSemantico {}

export class ErrorCancelacion extends ErrorTecnico {}

export class ErrorDeProtocoloDelServidor extends ErrorTecnico {}

export class ErrorDeProtocoloDelCliente extends ErrorTecnico {}

export class ErrorDelFlujoDeTrabajoDelBackend extends ErrorTecnico {}

export class ErrorNoConex extends ErrorTecnico {}



//DESFASADOS
// export class ErrorRepuestaDesconocidaDelServidor extends ErrorDeLaCapaDeServicios {}

// export class ErrorDesconocidoDelBackend extends ErrorDeLaCapaDeServicios {}
